var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.524 22 22 17.5242 22 12C22 6.47583 17.524 2 12 2C6.476 2 2 6.47583 2 12C2 17.5242 6.476 22 12 22ZM6.576 11.7833L16.218 8.06583C16.665 7.90417 17.056 8.175 16.911 8.85167L16.912 8.85083L15.27 16.585C15.148 17.1333 14.822 17.2667 14.367 17.0083L11.867 15.1658L10.661 16.3275C10.527 16.4608 10.415 16.5733 10.157 16.5733L10.334 14.0292L14.967 9.84333C15.169 9.66583 14.922 9.56583 14.657 9.7425L8.931 13.3475L6.462 12.5775C5.927 12.4075 5.915 12.0417 6.576 11.7833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d4fb623faa8cee3624572029a675a5d8.svg";
export { ForwardRef as ReactComponent };